import React from 'react'
import { Helmet } from 'react-helmet'
import CreatorAnalytics from '../../../components/CreatorAnalytics'

const Analytics = () => {
    return (
        <>
            <Helmet>
                <title>Analytics</title>
            </Helmet>          
            <CreatorAnalytics />
        </>
    )
}

export default Analytics
